import React from 'react';
import { motion } from 'framer-motion';

const SkillConnection = ({ 
  startPosition, 
  endPosition, 
  isActive = false, 
  strength = 1,
  connectionType = 'synergy' 
}) => {
  const getConnectionStyle = () => {
    switch (connectionType) {
      case 'synergy':
        return {
          color: 'rgba(0, 212, 255, 0.6)',
          strokeWidth: 2,
          dashArray: '0'
        };
      case 'enhancement':
        return {
          color: 'rgba(255, 107, 53, 0.5)',
          strokeWidth: 1.5,
          dashArray: '5,5'
        };
      case 'foundation':
        return {
          color: 'rgba(255, 51, 102, 0.4)',
          strokeWidth: 1,
          dashArray: '2,3'
        };
      default:
        return {
          color: 'rgba(184, 184, 209, 0.3)',
          strokeWidth: 1,
          dashArray: '0'
        };
    }
  };

  const style = getConnectionStyle();
  const opacity = isActive ? 1 : 0.3;
  const strokeWidth = isActive ? style?.strokeWidth * 1.5 : style?.strokeWidth;

  return (
    <motion.svg
      className="absolute inset-0 w-full h-full pointer-events-none"
      initial={{ opacity: 0 }}
      animate={{ opacity }}
      transition={{ duration: 0.3 }}
    >
      <motion.line
        x1={`${startPosition?.x}%`}
        y1={`${startPosition?.y}%`}
        x2={`${endPosition?.x}%`}
        y2={`${endPosition?.y}%`}
        stroke={style?.color}
        strokeWidth={strokeWidth}
        strokeDasharray={style?.dashArray}
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      />
      {/* Animated particles along the connection */}
      {isActive && (
        <motion.circle
          r="2"
          fill={style?.color}
          initial={{ 
            cx: `${startPosition?.x}%`, 
            cy: `${startPosition?.y}%` 
          }}
          animate={{ 
            cx: `${endPosition?.x}%`, 
            cy: `${endPosition?.y}%` 
          }}
          transition={{ 
            duration: 2, 
            repeat: Infinity, 
            ease: "linear" 
          }}
        />
      )}
    </motion.svg>
  );
};

export default SkillConnection;